import { render } from "./GalerieVideos.vue?vue&type=template&id=782cdc4d&scoped=true"
import script from "./GalerieVideos.vue?vue&type=script&lang=js"
export * from "./GalerieVideos.vue?vue&type=script&lang=js"

import "./GalerieVideos.vue?vue&type=style&index=0&id=782cdc4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782cdc4d"]])

export default __exports__